import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/NotFound.css';
import Header from './Header';
import Footer from './Footer';

const NotFound: React.FC = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <section className="section not-found-section">
          <div className="container">
            <div className="not-found-content">
              <h1>404</h1>
              <h2>Page Not Found</h2>
              <p>The page you are looking for doesn't exist or has been moved.</p>
              <div className="not-found-actions">
                <Link to="/" className="btn btn-primary">
                  Go to Home
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;






